import React from 'react';

interface CloseCircleIconProps {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
}

const CloseCircleIcon: React.FC<CloseCircleIconProps> = ({ 
  width = 12, 
  height = 13, 
  color = 'white',
  className,
  style 
}) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={width} 
      height={height} 
      fill="none" 
      viewBox="0 0 12 13"
      className={className}
      style={style}
    >
      <path 
        d="M10.2002 6.5C10.2002 4.1804 8.3196 2.2998 6 2.2998C3.6804 2.2998 1.7998 4.1804 1.7998 6.5C1.7998 8.8196 3.6804 10.7002 6 10.7002C8.3196 10.7002 10.2002 8.8196 10.2002 6.5ZM7.2876 4.78809C7.40476 4.67093 7.59476 4.67093 7.71191 4.78809C7.82903 4.90524 7.82903 5.09476 7.71191 5.21191L6.42383 6.49951L7.71191 7.7876C7.82907 7.90476 7.82907 8.09476 7.71191 8.21191C7.59476 8.32907 7.40476 8.32907 7.2876 8.21191L5.99951 6.92383L4.71191 8.21191C4.59476 8.32903 4.40524 8.32903 4.28809 8.21191C4.17093 8.09476 4.17093 7.90476 4.28809 7.7876L5.5752 6.49951L4.28809 5.21191C4.17093 5.09476 4.17093 4.90524 4.28809 4.78809C4.40524 4.67093 4.59476 4.67093 4.71191 4.78809L5.99951 6.0752L7.2876 4.78809ZM10.7998 6.5C10.7998 9.15097 8.65097 11.2998 6 11.2998C3.34903 11.2998 1.2002 9.15097 1.2002 6.5C1.2002 3.84903 3.34903 1.7002 6 1.7002C8.65097 1.7002 10.7998 3.84903 10.7998 6.5Z" 
        fill={color}
      />
    </svg>
  );
};

export default CloseCircleIcon;

